import { useTranslate } from './translation/use-translation'

export { useTranslate }
